export default __webpack_public_path__ + "static/media/10.923b3dda.jpg";